import { handleActions } from 'redux-actions';

const INITIAL_STATE = {
  playing: {},
  queue: [],
  position: 0,
  music_playing: false,
  time_remaining: 0,
  show_modal: true,
  next_song: null,
  next_song_state: null,
};

/**
 * player in state
 */
export const player = handleActions(
  {
    UPDATING_PLAYING: (state, action) => {
      return Object.assign({}, state, action.payload);
    },
    PLAY_NOW: (state, action) => {
      return Object.assign({}, state, action.payload);
    },
    ADD_TO_QUEUE: (state, action) => {
      return Object.assign({}, state, {
        queue: state.queue.concat(action.payload),
      });
    },
    PLAY: (state, action) => {
      return Object.assign({}, state, {
        music_playing: true,
      });
    },
    PAUSE: (state, action) => {
      return Object.assign({}, state, {
        music_playing: false,
      });
    },
    ADD_TOP_QUEUE: (state, action) => {
      if(action.payload == state.queue[state.position]) {
        return state;
      }

      return Object.assign({}, state, {
        queue: [action.payload].concat(state.queue),
        position: 0,
        music_playing: true,
      });
    },
    ADD_TOP_QUEUE_NO_AUTOPLAY: (state, action) => {
      if(action.payload == state.queue[state.position]) {
        return state;
      }

      return Object.assign({}, state, {
        queue: [action.payload].concat(state.queue),
        position: 0,
      });
    },
    NEXT_SONG: (state, action) => {
      return Object.assign({}, state, {
        position: (state.position + 1) < state.queue.length ? state.position + 1 : state.queue.length,
      });
    },
    PREVIOUS_SONG: (state, action) => {
      return Object.assign({}, state, {
        position: state.position > 0 ? state.position - 1 : 0,
      });
    },
    SET_TIME_REMAINING:  (state, action) => {
      return Object.assign({}, state, {
        time_remaining: action.payload,
      });
    },
    SET_SHOW_NEXT_SONG_MODAL:  (state, action) => {
      return Object.assign({}, state, {
        show_modal: action.payload,
      });
    },
    SET_NEXT_SONG:  (state, action) => {
      return Object.assign({}, state, {
        next_song: action.payload,
      });
    },
    SET_NEXT_SONG_STATE:  (state, action) => {
      return Object.assign({}, state, {
        next_song_state: action.payload,
      });
    },
  },
  INITIAL_STATE
);



// WEBPACK FOOTER //
// ./src/reducers/player.js